import React, { useContext } from "react";

export const CalenderCanCreateContext = React.createContext(null);
export const useCanCreateProvider = () => useContext(CalenderCanCreateContext);